<template>
    <div :class="`DshNumberange ycFormItem control-${mode}`">
        <!-- 组件无clearable -->
        <div class="DshNumberange-left">
            <BriInputNumber
                style="width: 100%;"
                v-model="value[propsObj._key][0]"
                :class="{
                    'DshNumberange-left-readonly': $isReadonly(canEdit, propsObj),
                    'DshNumberange-left-disabled': $isDisabled(canEdit, propsObj)
                }"
                :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}最小值` : ''"
                :disabled="!finalCanEdit"
                @on-change="change"
            ></BriInputNumber>

        </div>

        <span class="DshNumberange-center"> — </span>

        <div class="DshNumberange-right">
            <BriInputNumber
                style="width: 100%;"
                :class="{
                    'DshNumberange-right-readonly': $isReadonly(canEdit, propsObj),
                    'DshNumberange-right-disabled': $isDisabled(canEdit, propsObj)
                }"
                v-model="value[propsObj._key][1]"
                :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}最大值` : ''"
                :disabled="!finalCanEdit"
                @on-change="change"
            ></BriInputNumber>
        </div>
    </div>
</template>

<script>
    import BriInputNumber from "./DshNumber/BriInputNumber/BriInputNumber.vue";
    import controlMixin from "../controlMixin.js";

    export default {
        name: "DshNumberange",
        components: {
            BriInputNumber
        },
        mixins: [controlMixin],
        props: {
            value: {
                type: [Object, Array],
                default () {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {},
        created () {
        },
        methods: {
            change (...params) {
                this.$emit("change", ...params);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshNumberange.vue